document.addEventListener("DOMContentLoaded", () => {
  const sectionWrapper = document.getElementById("section-wrapper");
  if (!sectionWrapper) return;

  const sticky_button_show_all_time = sectionWrapper.dataset.stickyShowAllTime === 'true';

  (function initProductSliders() {
    if (typeof KeenSlider === 'undefined') return;

    const thumbnailEl = document.getElementById('product-keen-thumbnail-slider');
    const largeEl = document.getElementById('product-keen-large-slider');
    if (!thumbnailEl || !largeEl) return;

    if (thumbnailEl.dataset.skInit === '1') return;
    thumbnailEl.dataset.skInit = '1';

    function ThumbnailPlugin(main) {
      return function (slider) {
        function removeActive() {
          slider.slides.forEach(function (s) { s.classList.remove('active'); });
        }
        function addActive(idx) {
          if (slider.slides[idx]) slider.slides[idx].classList.add('active');
        }
        function addClickEvents() {
          slider.slides.forEach(function (slide, idx) {
            slide.addEventListener('click', function () { main.moveToIdx(idx); });
          });
        }

        const leftButton = document.getElementById('keen-large-slider-left');
        const rightButton = document.getElementById('keen-large-slider-right');

        if (rightButton) {
          rightButton.addEventListener('click', function () {
            if (!slider.track.details.atEnd) main.next();
          });
        }
        if (leftButton) {
          leftButton.addEventListener('click', function () {
            if (!slider.track.details.atStart) main.prev();
          });
        }

        slider.on('created', function () {
          addActive(slider.track.details.rel);
          addClickEvents();
          main.on('animationStarted', function (m) {
            removeActive();
            const next = m.animator.targetIdx || 0;
            addActive(m.track.absToRel(next));
            slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
          });
        });
      };
    }

    const largeSlider = new KeenSlider('#product-keen-large-slider', {
      loop: false,
      slides: { spacing: 0, perView: 1 }
    });

    new KeenSlider('#product-keen-thumbnail-slider', {
      loop: false,
      slides: { spacing: 10, perView: 6 },
      vertical: false,
      created: function () {
        thumbnailEl.querySelectorAll('.keen-slider__slide').forEach(function (slide) {
          slide.classList.remove('hidden');
        });
      }
    }, [ThumbnailPlugin(largeSlider)]);
  })();

  (function initGuaranteePopup() {
    const openBtn = document.getElementById("block-guarantee-popup-open-button");
    const wrapper = document.getElementById("block-guarantee-popup-wrapper");
    const closeBtn = document.getElementById("block-guarantee-popup-close-button");

    if (openBtn && wrapper) {
      openBtn.addEventListener("click", () => wrapper.classList.remove("hidden"));
    }
    if (closeBtn && wrapper) {
      closeBtn.addEventListener("click", () => wrapper.classList.add("hidden"));
    }
  })();

  (function initColorListScrollbar() {
    const el = document.querySelector(".color-list-slider-wrapper");
    if (!el) return;

    const bar = document.querySelector(".color-list-scrollbar");
    if (!bar) return;
    const track = bar.querySelector(".track");
    const thumb = bar.querySelector(".thumb");
    if (!track || !thumb) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let rafId = 0;
    let momentumRunning = false;

    const stopMomentum = () => {
      momentumRunning = false;
      cancelAnimationFrame(rafId);
    };

    const momentum = () => {
      momentumRunning = true;
      if (Math.abs(velocity) < 0.01) {
        momentumRunning = false;
        return;
      }
      el.scrollLeft -= velocity * 12;
      velocity *= 0.95;
      updateThumb();
      rafId = requestAnimationFrame(momentum);
    };

    el.addEventListener("dragstart", (e) => e.preventDefault());

    el.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      isDown = true;
      el.classList.add("grabbing");
      bar.classList.add("active");

      startX = e.clientX;
      startScrollLeft = el.scrollLeft;
      velocity = 0;
      lastX = e.clientX;
      lastTime = Date.now();
      stopMomentum();
    });

    window.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const dx = e.clientX - startX;
      el.scrollLeft = startScrollLeft - dx;

      const now = Date.now();
      const dt = now - lastTime;
      if (dt > 0) velocity = (e.clientX - lastX) / dt;
      lastX = e.clientX;
      lastTime = now;

      updateThumb();
    }, { passive: false });

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove("grabbing");
      setTimeout(() => bar.classList.remove("active"), 120);
      if (Math.abs(velocity) > 0.08) momentum();
    };

    window.addEventListener("mouseup", endDrag);
    el.addEventListener("mouseleave", endDrag);

    function updateThumb() {
      const cw = el.clientWidth;
      const sw = el.scrollWidth;
      const sl = el.scrollLeft;

      if (sw <= cw) {
        thumb.style.width = "0px";
        thumb.style.transform = "translateX(0)";
        return;
      }

      const trackW = track.clientWidth;
      const minThumb = 40;
      const thumbW = Math.max((cw / sw) * trackW, minThumb);
      const maxLeft = trackW - thumbW;
      const left = (sl / (sw - cw)) * maxLeft;

      thumb.style.width = thumbW + "px";
      thumb.style.transform = `translateX(${left}px)`;
    }

    function syncBarWidth() {
      updateThumb();
    }

    el.addEventListener("scroll", () => { updateThumb(); }, { passive: true });
    window.addEventListener("resize", syncBarWidth);

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => syncBarWidth());
      ro.observe(el);
      ro.observe(track);
    } else {
      setTimeout(syncBarWidth, 60);
    }

    syncBarWidth();
    setTimeout(syncBarWidth, 250);
  })();

  (function initStickyAtc() {
    const stickyButtonWrapper = document.querySelector('.byteex-stycky-atc-button-wrapper');
    const stickyButton = document.getElementById('byteex-stycky-atc-button');
    const stickyButtonText = document.getElementById('sticky_atc_button_text');
    const submitButton = document.getElementById('pick-your-colors-button');

    if (!(stickyButtonWrapper && stickyButtonText && submitButton)) return;

    const scrollTarget = document.getElementById('nail_picker') || submitButton;

    const scrollToElement = (el, offset = 0) => {
      if (!el) return;
      const targetY = el.getBoundingClientRect().top + window.scrollY - offset;
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      } else {
        window.scrollTo(0, targetY);
      }
    };

    stickyButtonWrapper.addEventListener('click', () => {
      scrollToElement(scrollTarget, 200);
    });

    const checkButtonPosition = () => {
      const currentSubmitButton = document.getElementById('pick-your-colors-button');
      if (!currentSubmitButton) return;
      const buttonRect = currentSubmitButton.getBoundingClientRect();
      if (buttonRect.bottom <= 70) {
        stickyButtonWrapper.style.transform = 'translateY(0px)';
      } else {
        stickyButtonWrapper.style.transform = 'translateY(140px)';
      }
    };

    if (!sticky_button_show_all_time) {
      window.addEventListener('scroll', checkButtonPosition);
    }

    stickyButton.addEventListener('click', (event) => {
      event.stopPropagation();
      const stickyLoader = document.getElementById('sticky_atc_button_loader');
      const loaderDisplayStyle = stickyLoader ? window.getComputedStyle(stickyLoader).display : 'none';
      const currentSubmitButton = document.getElementById('pick-your-colors-button');

      scrollToElement(scrollTarget, 300);

      if (currentSubmitButton && currentSubmitButton.getAttribute('type') === 'submit' && loaderDisplayStyle === 'none') {
        currentSubmitButton.click();
      }
    });
  })();

  (function initStarterKitB() {
    const root = document.querySelector('.btf-skb-wrap');
    if (!root) return;
    if (root.dataset.skbInit === 'true') return;
    root.dataset.skbInit = 'true';

    const toggle = root.querySelector('.btf-skb-toggle');
    const benefitItems = [
      ...root.querySelectorAll('.btf-skb-benefit'),
      ...document.querySelectorAll('.btf-subscription-block-benefit'),
    ];

    const variantPickerData = document.getElementById('variant-picker-data');
    let benefitWraps = variantPickerData
      ? parseInt(variantPickerData.dataset.wrapsNumber, 10) || 1
      : 1;
    let benefitTerm = '';

    function getCurrencySymbol() {
      return sectionWrapper.dataset.currencySymbol || '$';
    }

    function updateBenefitText(wraps, term, price) {
      if (wraps !== undefined && wraps !== null && wraps !== '') benefitWraps = wraps;
      if (term) benefitTerm = term;
      const displayPrice = (price || price === 0)
        ? ('\u00A0' + getCurrencySymbol() + price)
        : '';
      benefitItems.forEach((li) => {
        const template = li.dataset.benefitTemplate || '';
        const rendered = template
          .replace(/\[wraps\]/g, benefitWraps || '')
          .replace(/\[term\]/g, benefitTerm || '')
          .replace(/(?:[\$£€¥₹₽]\s*)?\[price\]/g, displayPrice);
        const textEl = li.querySelector('.btf-skb-benefit-text');
        if (textEl) textEl.textContent = rendered;
      });
    }

    function setOn(on) {
      root.classList.toggle('is-on', on);
      if (toggle) toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      window.__btfSubscribeOn = on;

      const onetimeData = document.getElementById('btf-skb-onetime-data');
      if (!on && onetimeData) {
        window.__btfStarterKitOnetimeVariantId = onetimeData.dataset.variantId;
        window.__btfStarterKitOnetimePrice = parseInt(onetimeData.dataset.price, 10);
        window.__btfStarterKitOnetimeComparePrice = parseInt(onetimeData.dataset.comparePrice, 10) || 0;
      } else {
        window.__btfStarterKitOnetimeVariantId = null;
      }

      const pickBtn = document.getElementById('pick-your-colors-button');
      const pdpBtnText = pickBtn ? pickBtn.querySelector('.button-text') : null;
      if (pdpBtnText && pickBtn.dataset.skComplete === '1') {
        pdpBtnText.textContent = on ? 'PROCEED TO CHECKOUT' : 'ADD TO CART';
      }

      const modalLabel = document.querySelector('#sk-step2-checkout .sk-checkout-label');
      if (modalLabel) {
        modalLabel.textContent = 'Proceed to checkout';
      }

      const modalGiftSection = document.querySelector('.sk-step2-gifts-section');
      if (modalGiftSection) {
        modalGiftSection.style.display = on ? '' : 'none';
      }
    }

    if (toggle) {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOn(!root.classList.contains('is-on'));
      });
    }

    document.addEventListener('btf-prices-updated', () => {
      const canon = window.__btfCanonicalPrices;
      if (!canon) return;
      if (canon.term) benefitTerm = canon.term;
      if (canon.subscriptionPriceText) {
        updateBenefitText(benefitWraps, benefitTerm, canon.subscriptionPriceText);
      }
    });

    updateBenefitText(benefitWraps, '', '');
    setOn(true);

    function overrideGiftImages() {
      const giftEls = document.querySelectorAll('#btf-subscription-gifts .btf-subscription-gift-data');
      if (!giftEls.length) return;
      giftEls.forEach((dataEl) => {
        const pos = dataEl.dataset.position;
        const customImg = dataEl.dataset.image;
        if (!pos || !customImg) return;

        // Update the traditional gift card in .sk-step2-gifts-section
        const modalCard = document.querySelector('.sk-step2-gift-card[data-position="' + pos + '"]');
        if (modalCard) {
          const modalImg = modalCard.querySelector('.sk-step2-gift-image img');
          if (modalImg && modalImg.src !== customImg) {
            modalImg.src = customImg;
          }
        }

        // ALSO update the inline gift tile in .sk-step2-selection (merge mode)
        const inlineTile = document.querySelector('.sk-step2-tile-gift[data-position="' + pos + '"]');
        if (inlineTile) {
          const inlineImg = inlineTile.querySelector('.sk-step2-tile-gift-image img');
          if (inlineImg && inlineImg.src !== customImg) {
            inlineImg.src = customImg;
          }
        }
      });
    }
    overrideGiftImages();
    setTimeout(overrideGiftImages, 100);
    setTimeout(overrideGiftImages, 500);
    setTimeout(overrideGiftImages, 1500);
    const modalEl = document.getElementById('sk-drawer');
    if (modalEl) {
      new MutationObserver(() => {
        if (modalEl.classList.contains('active')) overrideGiftImages();
      }).observe(modalEl, { attributes: true, attributeFilter: ['class'] });
    }
  })();

  (function initSlotsDragScroll() {
    const wrapper = document.querySelector('.btf-starter-kit-color-slots-wrapper.layout-scroll');
    if (!wrapper) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;

    const state = { active: false, startX: 0, scrollLeft: 0, moved: false };

    wrapper.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      state.active = true;
      state.moved = false;
      state.startX = e.pageX;
      state.scrollLeft = wrapper.scrollLeft;
      wrapper.classList.add('is-dragging');
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (!state.active) return;
      const delta = state.startX - e.pageX;
      if (Math.abs(delta) > 3) state.moved = true;
      wrapper.scrollLeft = state.scrollLeft + delta;
    });

    const endDrag = () => {
      if (!state.active) return;
      state.active = false;
      wrapper.classList.remove('is-dragging');
    };
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('mouseleave', endDrag);

    wrapper.addEventListener('click', (e) => {
      if (state.moved) {
        e.stopImmediatePropagation();
        state.moved = false;
      }
    }, true);
  })();

  (function initBuildABoxPricing() {
    const productId = sectionWrapper.dataset.productId;
    const perUnitPence = parseInt(sectionWrapper.dataset.price, 10) || 0;
    const currencySymbol = sectionWrapper.dataset.currencySymbol || '$';

    const variantPickerData = document.getElementById('variant-picker-data');
    const wrapsNumber = variantPickerData
      ? parseInt(variantPickerData.dataset.wrapsNumber, 10) || 1
      : 1;

    const onetimeData = document.getElementById('btf-skb-onetime-data');
    const onetimePence = onetimeData ? parseInt(onetimeData.dataset.price, 10) || 0 : 0;
    const onetimeComparePence = onetimeData ? parseInt(onetimeData.dataset.comparePrice, 10) || 0 : 0;

    const skbWrap = document.querySelector('.btf-skb-wrap');
    const skbToggle = skbWrap ? skbWrap.querySelector('.btf-skb-toggle') : null;
    const skbTitleEl = skbWrap ? skbWrap.querySelector('.btf-skb-title-text') : null;
    const skbTitleTemplate = skbWrap ? skbWrap.dataset.titleTemplate || '' : '';

    const paidGiftTotalPence = skbWrap
      ? parseInt(skbWrap.dataset.giftTotalPence, 10) || 0
      : 0;

    let subscriptionDiscountPct = 0;
    let subscriptionTermText = '';

    if (!productId || !perUnitPence) {
      window.btfBuildABoxReady = Promise.resolve(null);
      revealLoader();
      return;
    }

    window.btfBuildABoxReady = fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productPlatformId: String(productId) }),
    })
      .then((r) => r.json())
      .then((data) => {
        window.btfBuildABoxData = data;

        const tiers = data && data.DynamicBox && data.DynamicBox.percentDiscountTier;
        if (tiers) {
          const firstTierValue = Object.values(tiers)[0];
          subscriptionDiscountPct = Number(firstTierValue) || 0;
        }

        const sellingPlanGroup = data && data.DynamicBox && data.DynamicBox.sellingPlanGroup;
        if (sellingPlanGroup) {
          const firstPlan = Object.values(sellingPlanGroup)
            .sort((a, b) => (a && a.position || 0) - (b && b.position || 0))[0];
          if (firstPlan) {
            const count = Number(firstPlan.intervalCount);
            const unit = firstPlan.interval ? String(firstPlan.interval).toLowerCase() : '';
            if (Number.isFinite(count) && count > 0 && unit) {
              subscriptionTermText = count + ' ' + unit + (count > 1 ? 's' : '');
            }
          }
        }

        applySelectableProducts(data);
        renderPrices();
      })
      .catch((err) => {
        console.error('[btf] Build-a-Box fetch failed', err);
        renderPrices();
      });

    if (skbToggle) {
      skbToggle.addEventListener('click', () => {
        renderPrices();
        syncPickerMode();
        document.dispatchEvent(new CustomEvent('btf-reset-picker'));
      });
    }

    syncPickerMode();

    function applySelectableProducts(data) {
      const selectable = data && data.DynamicBox && data.DynamicBox.selectableProductVariants;
      if (!Array.isArray(selectable) || selectable.length === 0) return;

      const allowedProductIds = new Set(
        selectable
          .map((p) => p && p.productPlatformId)
          .filter(Boolean)
          .map((gid) => gid.replace('gid://shopify/Product/', ''))
      );

      document.querySelectorAll('.sk-color-card[data-list="subscription"]').forEach((card) => {
        if (!allowedProductIds.has(card.dataset.productId)) {
          card.classList.add('hidden');
        }
      });
    }

    function syncPickerMode() {
      const list = document.getElementById('sk-drawer-color-list');
      if (!list) return;
      const mode = (skbWrap && skbWrap.classList.contains('is-on')) ? 'subscription' : 'onetime';
      if (list.dataset.mode !== mode) {
        list.dataset.mode = mode;
      }
    }

    function fmt(pence) {
      return (pence / 100).toFixed(2);
    }

    function revealLoader() {
      document.querySelectorAll('.price-block-loader').forEach((el) => el.classList.add('hidden'));
      document.querySelectorAll('.price-block-content').forEach((el) => el.classList.remove('hidden'));
      document.documentElement.classList.add('sk-prices-loaded');
    }

    function renderPrices() {
      const isSubscription = skbWrap ? skbWrap.classList.contains('is-on') : true;

      const subDiscountedPerUnitPence = subscriptionDiscountPct > 0
        ? Math.round(perUnitPence * (1 - subscriptionDiscountPct / 100))
        : perUnitPence;
      const subBasePence = perUnitPence * wrapsNumber;
      const subDiscountedPence = subDiscountedPerUnitPence * wrapsNumber;
      const subInflatedComparePence = subBasePence + paidGiftTotalPence;
      const subHasDiscount = subInflatedComparePence > subDiscountedPence;
      const subscriptionSavePercent = subHasDiscount && subInflatedComparePence > 0
        ? Math.round(((subInflatedComparePence - subDiscountedPence) / subInflatedComparePence) * 100)
        : 0;

      let pricePence;
      let comparePence;
      let savePercent;
      let hasDiscount;

      if (isSubscription) {
        pricePence = subDiscountedPence;
        comparePence = subInflatedComparePence;
        hasDiscount = subHasDiscount;
        savePercent = subscriptionSavePercent;
      } else if (onetimePence > 0) {
        pricePence = onetimePence;
        comparePence = pricePence;
        hasDiscount = false;
        savePercent = 0;
      } else {
        pricePence = perUnitPence * wrapsNumber;
        comparePence = pricePence;
        hasDiscount = false;
        savePercent = 0;
      }

      const savingsPence = hasDiscount ? comparePence - pricePence : 0;
      const priceStr = fmt(pricePence);
      const compareStr = fmt(comparePence);

      if (skbTitleEl && skbTitleTemplate) {
        skbTitleEl.textContent = skbTitleTemplate.replace(/\[percent\]/g, subscriptionSavePercent);
      }

      document.querySelectorAll('.price-block-content-price').forEach((el) => {
        el.textContent = priceStr;
      });
      document.querySelectorAll('.price-block-content-compare-price').forEach((el) => {
        el.textContent = compareStr;
        const wrap = el.parentElement;
        if (wrap) wrap.style.display = hasDiscount ? '' : 'none';
      });
      document.querySelectorAll('.price-block-content-discount').forEach((el) => {
        el.textContent = savePercent;
        const wrap = el.parentElement;
        if (wrap) wrap.style.display = hasDiscount ? '' : 'none';
      });

      applyToButton(document.getElementById('pick-your-colors-button'), priceStr, compareStr, hasDiscount);

      applyToButton(document.getElementById('byteex-stycky-atc-button'), priceStr, compareStr, hasDiscount);

      const modalBtn = document.getElementById('sk-step2-checkout');
      if (modalBtn) {
        const modalPriceEl = modalBtn.querySelector('.sk-checkout-price');
        const modalCompareEl = modalBtn.querySelector('.sk-checkout-compare');
        if (modalPriceEl) modalPriceEl.textContent = currencySymbol + priceStr;
        if (modalCompareEl) {
          modalCompareEl.textContent = currencySymbol + compareStr;
          modalCompareEl.style.display = hasDiscount ? '' : 'none';
        }
      }
      const savingsEl = document.querySelector('.sk-step2-savings-amount');
      const savingsRow = document.querySelector('.sk-step2-savings-row');
      const showSavingsRow = isSubscription && hasDiscount && savingsPence > 0;
      if (savingsRow) savingsRow.style.display = showSavingsRow ? '' : 'none';
      if (savingsEl) {
        savingsEl.textContent = showSavingsRow ? currencySymbol + fmt(savingsPence) : '';
      }

      revealLoader();

      window.__btfCanonicalPrices = {
        mode: isSubscription ? 'subscription' : 'onetime',
        priceText: priceStr,
        compareText: currencySymbol + compareStr,
        savePercent: savePercent,
        hasDiscount: hasDiscount,
        currencySymbol: currencySymbol,
        term: subscriptionTermText,
        subscriptionPriceText: fmt(subDiscountedPence),
      };
      document.dispatchEvent(new CustomEvent('btf-prices-updated'));
    }

    function applyToButton(btn, priceStr, compareStr, hasDiscount) {
      if (!btn) return;
      const priceEl = btn.querySelector('.price');
      const compareEl = btn.querySelector('.compare-price');
      const compareSymEl = btn.querySelector('.compare-price-currency-symbol');
      if (priceEl) priceEl.textContent = priceStr;
      if (compareEl) {
        compareEl.textContent = compareStr;
        compareEl.style.display = hasDiscount ? '' : 'none';
      }
      if (compareSymEl) compareSymEl.style.display = hasDiscount ? '' : 'none';
    }
  })();

  (function initTwoVideoBlock() {
    const btn1 = document.getElementById("two-video-block-button-1");
    const btn2 = document.getElementById("two-video-block-button-2");
    const vid1 = document.getElementById("two-video-block-video-1");
    const vid2 = document.getElementById("two-video-block-video-2");
    if (!(btn1 && btn2 && vid1 && vid2)) return;

    btn1.addEventListener("click", () => {
      vid1.classList.remove("hidden");
      vid2.classList.add("hidden");
      btn1.style.borderBottom = "thin solid #211912";
      btn2.style.borderBottom = "none";
    });

    btn2.addEventListener("click", () => {
      vid1.classList.add("hidden");
      vid2.classList.remove("hidden");
      btn1.style.borderBottom = "none";
      btn2.style.borderBottom = "thin solid #211912";
    });
  })();
});
